import React from "react";
import '../styles/appointment.css';

const Stepper = ({ totalSteps, currentStep }) => {
    return (
        
        <div className="form-steps">
            <div >
                <div className="col-sm-12">
                    <div className="custom-stpper">
                        <ul>
                            {Array.from({ length: totalSteps }, (_, index) => (
                                <li
                                    key={index}
                                    className={
                                        currentStep > index + 1
                                            ? "success"
                                            : currentStep === index + 1
                                                ? "current"
                                                : ""
                                    }
                                >
                                    {currentStep > index + 1 ? (
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            height="18px"
                                            viewBox="0 -960 960 960"
                                            width="18px"
                                            fill="#e8eaed"
                                        >
                                            <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
                                        </svg>
                                    ) : (
                                        index + 1 // Display step number dynamically
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Stepper;
